var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.762%",
    y1: "-16.133%",
    x2: "4.73%",
    y2: "111.948%",
    id: "4gq303qisa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A4FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C5690",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.92V9.943c0-.96.508-1.849 1.336-2.336L12.893.808a2.71 2.71 0 0 1 2.748 0l11.557 6.8a2.71 2.71 0 0 1 1.335 2.335V23.92c0 .952-.5 1.835-1.317 2.324L15.66 33.166a2.71 2.71 0 0 1-2.785 0L1.317 26.244A2.71 2.71 0 0 1 0 23.92z",
    fill: "url(#4gq303qisa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.97 23.227-3.227-2.853a.339.339 0 0 1-.005-.503l3.003-2.746a.339.339 0 0 0-.004-.503L7.743 13.95a.339.339 0 0 1 .143-.581l12.86-3.23a.339.339 0 0 1 .41.412l-3.218 12.68a.339.339 0 0 1-.57.153L14.46 20.39a.339.339 0 0 0-.495.01l-2.519 2.8a.339.339 0 0 1-.476.026z",
    fill: "#FFF"
  }))));
};
export default SvgLogo;